module.exports = __webpack_public_path__ + "static/media/3.1645db59.jpg";